import { useTranslation } from 'react-i18next';
import Modal from 'shared/overlays/Modal';
import LanguageSelector from 'shared/forms/LanguageSelector';
import { useState } from 'react';

interface SelectLanguageModalProps {
  title?: string;
  show?: boolean;
  onSubmit: (locale: string) => void;
  onClose: () => void;
  currentLocale?: string;
  confirmText?: string;
}

export const SelectLanguageModal = ({ title, show, onSubmit, onClose, currentLocale, confirmText }: SelectLanguageModalProps) => {
  const { t } = useTranslation('common');

  const [selectedLocale, setSelectedLocale] = useState(currentLocale ?? '');
  return (
    <Modal show={!!show} onClose={onClose}>
      <div className="header d-flex">
        <h3>{title}</h3>
        <div className="close" onClick={onClose}>
          <i className="fa-regular fa-xmark" />
        </div>
      </div>
      <div className="body ">
        <LanguageSelector locale={selectedLocale} onChange={setSelectedLocale} />
      </div>
      <div className="d-flex justify-content-end mt-4">
        <button onClick={onClose} type="button" className="btn">
          {t('cancel')}
        </button>
        <button
          type="button"
          onClick={() => {
            onSubmit(selectedLocale);
          }}
          className="btn btn-primary"
        >
          {confirmText}
        </button>
      </div>
    </Modal>
  );
};
